<div class="product-services-form-container">
  <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="product-services-form">
    
    <!-- Basic Information Section -->
    <div class="form-section">
      <h3 class="section-title">{{ "Basic Information" | translator }}</h3>
      
      <div class="form-row">
        <div class="form-group">
          <label for="name" class="form-label">
            {{ "Service Name" | translator }} <span class="required">*</span>
          </label>
          <input type="text" id="name" formControlName="name" class="input-ui" 
                 [class.is-invalid]="productForm.get('name')?.invalid && productForm.get('name')?.touched"
                 placeholder="{{ 'Enter service name' | translator }}" />
          <div *ngIf="productForm.get('name')?.invalid && productForm.get('name')?.touched" class="invalid-feedback">
            {{ "Service name is required" | translator }}
          </div>
        </div>
        
        <div class="form-group">
          <label for="type" class="form-label">
            {{ "Product Type" | translator }}
          </label>
          <p-dropdown 
            id="type" 
            formControlName="type" 
            [options]="productTypes" 
            optionLabel="name" 
            optionValue="_id"
            placeholder="{{ 'Select product type' | translator }}"
            class="w-100"
            [style]="{'width': '100%'}"
            [disabled]="loadingProductTypes">
            <ng-template let-productType pTemplate="item">
              <div class="d-flex align-items-center gap-2">
                <span class="type-letter-badge">{{ productType.letter }}</span>
                <span>{{ productType.name }}</span>
              </div>
            </ng-template>
          </p-dropdown>
          <small *ngIf="loadingProductTypes" class="form-text text-muted">
            {{ "Loading product types..." | translator }}
          </small>
        </div>
      </div>
      
      <div class="form-row">
        <div class="form-group">
          <label for="servicePurpose" class="form-label">
            {{ "Service Purpose" | translator }}
          </label>
          <input type="text" id="servicePurpose" formControlName="servicePurpose" class="input-ui"
                 placeholder="{{ 'e.g., For querying financial statements' | translator }}" />
        </div>
      </div>
      
      <div class="form-group">
        <label for="serviceType" class="form-label">
            {{ "Service Type" | translator }}
        </label>
        <input type="text" id="serviceType" formControlName="serviceType" class="input-ui"
               placeholder="{{ 'e.g., ONE TIME' | translator }}" />
      </div>
    </div>
    
    <!-- Pricing Information Section -->
    <div class="form-section">
      <h3 class="section-title">{{ "Pricing Information" | translator }}</h3>
      
      <div formGroupName="pricing">
        <div class="form-group">
          <label for="amount" class="form-label">
            {{ "Amount" | translator }} <span class="required">*</span>
          </label>
          <input type="text" id="amount" formControlName="amount" class="input-ui"
                 [class.is-invalid]="productForm.get('pricing.amount')?.invalid && productForm.get('pricing.amount')?.touched"
                 placeholder="{{ 'Enter amount (e.g., 1000.00) or text (e.g., Not decided yet)' | translator }}" />
          <div *ngIf="productForm.get('pricing.amount')?.invalid && productForm.get('pricing.amount')?.touched" class="invalid-feedback">
            {{ "Amount is required" | translator }}
          </div>
            <small class="form-text text-muted">
              {{ "You can enter a number (e.g., 1000.00) or text (e.g., 'Not decided yet', 'Price to be determined')" | translator }}
            </small>
        </div>
        
        <div class="form-group">
          <label class="form-label">
            <input type="checkbox" formControlName="includesVAT" />
            {{ "Price includes VAT" | translator }}
          </label>
        </div>
      </div>
    </div>
    
    <!-- Service Details Section -->
    <div class="form-section">
      <h3 class="section-title">{{ "Service Details" | translator }}</h3>
      
      <div class="form-group">
        <label for="serviceDescription" class="form-label">
          {{ "Service Description" | translator }} <span class="required">*</span>
        </label>
        <textarea id="serviceDescription" formControlName="serviceDescription" class="input-ui" rows="4"
                  [class.is-invalid]="productForm.get('serviceDescription')?.invalid && productForm.get('serviceDescription')?.touched"
                  placeholder="{{ 'Enter service description' | translator }}"></textarea>
        <div *ngIf="productForm.get('serviceDescription')?.invalid && productForm.get('serviceDescription')?.touched" class="invalid-feedback">
          {{ "Service description is required" | translator }}
        </div>
      </div>
      
      <div class="form-group">
        <label for="serviceConditions" class="form-label">
          {{ "Service Conditions and Requirements" | translator }} <span class="required">*</span>
        </label>
        <textarea id="serviceConditions" formControlName="serviceConditions" class="input-ui" rows="4"
                  [class.is-invalid]="productForm.get('serviceConditions')?.invalid && productForm.get('serviceConditions')?.touched"
                  placeholder="{{ 'Enter service conditions and requirements' | translator }}"></textarea>
        <div *ngIf="productForm.get('serviceConditions')?.invalid && productForm.get('serviceConditions')?.touched" class="invalid-feedback">
          {{ "Service conditions and requirements are required" | translator }}
        </div>
      </div>
      
      <div class="form-group">
        <label for="targetAudience" class="form-label">
          {{ "Target Audience" | translator }}
        </label>
        <input type="text" id="targetAudience" formControlName="targetAudience" class="input-ui"
               placeholder="{{ 'Enter target audience' | translator }}" />
      </div>
      
      <!-- <div class="form-row">
        <div class="form-group">
          <label for="serviceFees" class="form-label">
            Service Fees
          </label>
          <input type="text" id="serviceFees" formControlName="serviceFees" class="input-ui"
                 placeholder="e.g., SAR 276,000 including VAT" />
        </div>
        
        <div class="form-group">
          <label for="singleQueryPrice" class="form-label">
            Single Query Price
          </label>
          <input type="text" id="singleQueryPrice" formControlName="singleQueryPrice" class="input-ui"
                 placeholder="e.g., 195.5 SAR *including VAT" />
        </div>
      </div> -->
      
      <div class="form-group">
        <label for="otherInformation" class="form-label">
          {{ "Other Information" | translator }}
        </label>
        <textarea id="otherInformation" formControlName="otherInformation" class="input-ui" rows="3"
                  placeholder="{{ 'Enter any other relevant information' | translator }}"></textarea>
      </div>
    </div>
    

    <!-- Survey Section -->
    <div class="form-section">
      <h3 class="section-title">{{ "Survey form" | translator }}</h3>

      <!-- toggle to create new or add existing survey -->

      <div class="form-group">
        <label class="form-label">
            <input type="radio" name="surveyOption" [checked]="createNewSurvey" (change)="createNewSurvey = true" />
            {{ "Create New Survey (products services)" | translator }}
            <br>
            <input type="radio" name="surveyOption" [checked]="!createNewSurvey" (change)="createNewSurvey = false" />
            {{ "Add Existing Survey" | translator }}
        </label>
      </div>

      <hr class="divider" />

      <div *ngIf="!createNewSurvey" class="form-group">
        <label for="existingSurvey" class="form-label">
          {{ "Select Existing Survey" | translator }}
        </label>
        
        <!-- Loading State -->
        <div *ngIf="isSurveysLoading" class="mb-3">
          <p-progressSpinner [style]="{width: '30px', height: '30px'}"></p-progressSpinner>
          <span style="color: black;" class="ml-2">{{ "Loading surveys..." | translator }}</span>
        </div>
        
        <!-- Survey Dropdown -->
        <select 
          id="existingSurvey" 
          class="input-ui mb-3"
          [(ngModel)]="selectedSurveyId"
          [ngModelOptions]="{standalone: true}"
          (change)="onSurveySelect(selectedSurveyId)"
          [disabled]="isSurveysLoading">
          <option value="">{{ "Please Select a survey" | translator }}</option>
          <option *ngFor="let survey of surveys" [value]="survey._id">
            {{ survey.name }}
          </option>
        </select>

        <label for="surveyLink" class="form-label">
          {{ "Survey Link" | translator }}
        </label>
        <input type="url" id="surveyLink" formControlName="surveyLink" class="input-ui"
               placeholder="{{ 'Enter survey link or select from above' | translator }}" />

        <button *ngIf="productForm.get('surveyLink')?.value?.includes(siteUrl + 'sa/survey/attempt/')" 
          type="button" class="btn btn-outline-secondary mt-2" (click)="checkLink()">
          <i class="pi pi-pencil"></i> {{ "Edit Questions" | translator }}
        </button>
      </div>

      <div *ngIf="createNewSurvey" class="form-group">
        <label for="newSurveyDetails" class="form-label">
          {{ "New Survey Details" | translator }}
        </label>
        <!-- <select id="surveyType" formControlName="surveyType" class="input-ui">
          <option value="" disabled selected>{{ "Select Survey Type" | translator }}</option>
          <option *ngFor="let type of surveyTypes" [value]="type._id">{{ type.name }}</option>
        </select> -->
        <input type="text" id="surveyName" formControlName="surveyName" class="input-ui" placeholder="{{ 'Enter Survey Name' | translator }}" />
        <textarea id="surveyDescription" formControlName="surveyDescription" class="input-ui" rows="3" placeholder="{{ 'Enter Survey Description' | translator }}"></textarea>
        
        <button type="button" class="btn btn-outline-primary" (click)="createSurvey()">
          <i class="pi pi-plus"></i> {{ "Create" | translator }}
        </button>
      </div>
    </div>



    <!-- Form Actions -->
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        {{ "Cancel" | translator }}
      </button>
      <button type="submit" 
              class="btn btn-primary" 
              [disabled]="!productForm.valid || isSubmitting || (isEditMode ? !permissionService.hasPermission('PRODUCT_SERVICE', 'u') : !permissionService.hasPermission('PRODUCT_SERVICE', 'c'))">
        <i class="pi pi-spinner pi-spin" *ngIf="isSubmitting"></i>
        <i class="pi pi-check" *ngIf="!isSubmitting"></i>
        {{ isSubmitting ? (isEditMode ? ('Updating...' | translator) : ('Creating...' | translator)) : (isEditMode ? ('Update Service' | translator) : ('Create Service' | translator)) }}
      </button>
    </div>
  </form>

</div>
<p-dialog 
  [blockScroll]="true" 
  [draggable]="false" 
  [header]="'Add Question' | translator" 
  [(visible)]="showAddQuestionView"
  [style]="{ width: '98vw', maxWidth: '1600px' }"
  [maximizable]="true"
  [closable]="true"
  (onHide)="closeAddQuestionView()">
  <app-add-question 
    *ngIf="currentQuestionSurveyId && showAddQuestionView"
    [surveyAssessmentIdInput]="currentQuestionSurveyId"
    [fromInput]="'survey'"
    [fromTrainingInput]="true"
    [isAssessmentInput]="false"
    [questionBankIdInput]="currentQuestionBankId"
    (questionsSaved)="onQuestionsSaved()">
  </app-add-question>
</p-dialog>